module.exports = __webpack_public_path__ + "assets/media/vokrug-3.5177cd88.svg";